import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/tipospagtos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findTipoPagamento(
  empresa_cnpj,
  where = {},
  include = ""
) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${queryWhere}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}

export async function findTypePaymentByFormOfPayment({
  empresa_cnpj,
  idTypePayment,
  include,
  where = {},
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });
  return search(
    `${path}/${idTypePayment}?empresa_cnpj=${empresa_cnpj}${queryWhere}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}
